<section class="py-8 md:py-16 xl:py-16  antialiased">
  <div class="max-w-screen-xl mx-auto">
    <div class="lg:flex justify-between">
      <div class="px-4">
        <div class="max-w-md lg:max-w-none mx-auto flex flex-col lg:flex-row justify-center mb-4">
          <img
            class="object-contain w-full h-full  dark:block"
            [src]="prestazione?.img"
            alt=""
          />
        </div>

        <div>
          <p class="text-label font-adobe mt-2">Nel caso non arrivasse il messaggio WhatsApp di conferma, volessi spostare o disdire la prenotazione, sempre e solo TELEFONICAMENTE almeno 4 ore prima!</p>
        </div>



      </div>

      <div class="w-full mt-6 lg:max-w-lg lg:mt-0 shrink-0 px-4">
        <div
          class="p-4 sm:p-6 lg:p-8 bg-secondary"
        >
          <h1 class="mb-3 text-xl font-bold font-adobe text-primary">
            PRENOTA VELOCE
          </h1>

            <div class="mx-auto max-w-2xl">
              <form (submit)="onSave(prenotazioneForm)" #prenotazioneForm="ngForm">
                <div class="grid gap-4 grid-cols-2 sm:grid-cols-1">

                  <!-- Giorno -->
                  <div class="w-full lg:col-span-1 md:col-span-2 sm:col-span-2">
                    <label for="day" class="label">Seleziona il giorno</label>
                    <input type="date" [(ngModel)]="day" name="day" id="day" (ngModelChange)="getSlots()"
                           [min]="minDate" [max]="maxDate"
                           class="input"
                           required>
                  </div>

                  <!-- Orario -->
                  <div class="w-full lg:col-span-1 md:col-span-2 sm:col-span-2">
                    <label for="slot" class="label">Seleziona orario disponibile</label>
                    <select
                      name="slot"
                      id="slot"
                      [(ngModel)]="slot"
                      class="input"
                      (ngModelChange)="checkSlot()"
                      required
                    >
                      <option value="" disabled>Premere qui per selezionare l'orario</option>
                      <option *ngFor="let item of slots" [value]="item">{{ item }}</option>
                    </select>
                    <p *ngIf="invalid.slot" class="message-error">Slot orario obbligatorio</p>
                  </div>

                  <!-- Nome -->
                  <div class="w-full col-span-2">
                    <label for="nome" class="label">Nome</label>
                    <input
                      type="text"
                      name="nome"
                      id="nome"
                      class="input"
                      [(ngModel)]="prenotazione.nome"
                      (ngModelChange)="checkNome()"
                      required
                    >
                    <p *ngIf="invalid.nome" class="message-error">Nome obbligatorio</p>
                  </div>

                  <!-- Cognome -->
                  <div class="w-full lg:col-span-1 md:col-span-2 sm:col-span-2">
                    <label for="cognome" class="label">Cognome</label>
                    <input
                      type="text"
                      name="cognome"
                      id="cognome"
                      class="input"
                      [(ngModel)]="prenotazione.cognome"
                      (ngModelChange)="checkCognome()"
                      required
                    >
                    <p *ngIf="invalid.cognome" class="message-error">Cognome obbligatorio</p>
                  </div>

                  <!-- Cellulare -->
                  <div class="w-full col-span-2">
                    <label for="cellulare" class="label">Cellulare</label>
                    <input
                      type="number"
                      name="cellulare"
                      id="cellulare"
                      class="input"
                      [(ngModel)]="prenotazione.cellulare"
                      (ngModelChange)="checkCellulare()"
                      required
                    >
                    <p *ngIf="invalid.cellulare" class="message-error">Cellulare obbligatorio</p>
                  </div>
                </div>
                <div class="flex-start items-center justify-center">
                  <button type="submit"
                          [disabled]="isSubmitting"
                          class="btn-primary">
                    Prenota
                  </button>
                </div>

              </form>
            </div>

          <p class="font-adobe mt-4 md:mt-6 text-sm font-normal text-label ">
            Prenotando la tua seduta confermi di aver letto e accettato i nostri
            <a href="https://www.termsfeed.com/live/5d1ed993-be1c-4045-b5c2-65d51af24777" target="_blank"
               class="font-adobe font-medium underline text-primary hover:no-underline dark:text-primary">Termini e Condizioni
              </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
